module.exports = __webpack_public_path__ + "media/images/ticket-partners/afisha-bf22833285bf7b4a54d979df7ee5ea8d.png";